import React, { FC, useEffect } from 'react';
import Image from 'next/image';
import styles from './index.module.scss';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  src: string;
  material: string;
  size: string;
};

export const Modal: FC<Props> = ({
  isOpen,
  handleClose,
  src,
  material,
  size,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(styles.noScroll);
    } else {
      document.body.classList.remove(styles.noScroll);
    }
    return () => {
      document.body.classList.remove(styles.noScroll);
    };
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={(e) => e.stopPropagation()}>
      <div
        className={isOpen ? styles.openModal : styles.modal}
        onClick={handleClose}
      >
        <Image
          src={src || ''}
          alt={`Artpiece by Karen Oude Alink. Made with ${material} materials and the sizes are: ${size}.`}
          fill
          className={styles.imgModal}
          sizes="(min-width: 300px) 80vw, (min-width: 600px) 80vw 60vw 30vw, (min-width: 900px) 70vw 50vw 30vw 25vw 15vw, (min-width: 1250px) 70vw 50vw 30vw 25vw 15vw,"
        />
        <ul className={styles.modalInfo}>
          <li>Untitled</li>
          <li>Material: {material}</li>
          <li>Sizes: {size}</li>
        </ul>
      </div>
    </div>
  );
};
